import linkedin from "../Svgs/medias/in.svg";
import codepen from "../Svgs/medias/codepen.svg";
import fb from "../Svgs/medias/fb.svg";
import github from "../Svgs/medias/github.svg";
import stackoverflow from "../Svgs/medias/stackoverflow.svg";
import twitch from "../Svgs/medias/twitch.svg";
import twitter from "../Svgs/medias/twitter.svg";
import youtube from "../Svgs/medias/youtube.svg";
import gitlab from "../Svgs/medias/gitlab.svg";
import personal from "../Svgs/medias/personal.svg";

export const data = [
  { title: "Github", icon: github, color: "#1A1B1B", valid: "github" },
  { title: "Twitter", icon: twitter, color: "#42B7E8", valid: "twitter" },
  { title: "LinkedIn", icon: linkedin, color: "#0A67C3", valid: "linkedin" },
  { title: "YouTube", icon: youtube, color: "#EE3939", valid: "youtube" },
  { title: "Facebook", icon: fb, color: "#2543AC", valid: "facebook" },
  { title: "Twitch", icon: twitch, color: "#9146FE", valid: "twitch.tv" },
  { title: "Codepen", icon: codepen, color: "#1A1B1B", valid: "codepen" },
  {
    title: "Stack Overflow",
    icon: stackoverflow,
    color: "#ED7101",
    valid: "stackoverflow",
  },
  { title: "GitLab", icon: gitlab, color: "#DA4127", valid: "gitlab" },
  { title: "Personal", icon: personal, color: "#1A1B1B", valid: "personal" },
];
